import { t } from '../../i18n.es.js';
import React from 'react';
import slug from '@teko/slug';
import { styled, LazyImage, Currency } from '@teko/ui';
import { CustomLink } from '../../Common/CustomLink/CustomLink.es.js';
import { TableDivider } from '../TableDivider/TableDivider.es.js';

const OrderItemsWrapper = styled.table`
  margin-top: 16px;
  border-radius: 8px;
  background-color: white;
  overflow: hidden;
  font-size: 14px;
  color: #333;
  border-spacing: 0;
  width: 100%;
  border-collapse: initial;

  p {
    margin: 0;
    padding: 0;
  }

  td {
    vertical-align: top;
  }

  th {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    border-bottom: 1px solid #e0e0e0;
    padding: 16px;
    &:nth-of-type(1) {
      width: 52%;
    }

    &:nth-of-type(2) {
      width: 17%;
    }

    &:nth-of-type(4) {
      width: 17%;
    }

    &:nth-of-type(5) {
      width: 14%;
    }
  }
`;
const OrderProduct = styled.tr`
  td {
    padding: 16px;
  }
`;
const ProductItem = styled.td`
  display: flex;
  justify-content: space-between;
`;
const ProductItemRight = styled.div`
  margin-left: 16px;

  & > :not(:last-child) {
    margin-bottom: 4px;
  }
`;
const ItemImg = styled(LazyImage)`
  width: 56px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  margin: 0;
  padding: 0;
  max-width: 56px;
`;
const ItemName = styled.p`
  word-wrap: break-word;
  line-height: 20px;
`;
const ItemSku = styled.p`
  font-size: 14px;
  color: #848788;
  line-height: 20px;
  margin-top: 4px;
`;
const ItemPrice = styled.td`
  text-align: right;
`;
const ItemFinalPrice = styled(ItemPrice)`
  font-weight: 700;
`;
const ItemQuantity = styled.td`
  text-align: center;
`;
const TableHead = styled.th(({ direction }) => `
    text-align: ${direction};
    font-weight: 700 !important;
  `);
const OrderPrize = styled.tr`
  td {
    padding: 0 16px 8px 16px;
  }
`;
const PrizeItem = styled(ProductItem)(({ last }) => `
    display: flex;
    padding-left: 40px !important;
    padding-bottom: ${last ? "16px !important" : ""};
  `);
const PrizeImg = styled(ItemImg)`
  margin-right: 16px;
  width: 32px;
  height: 32px;
  max-width: 32px;
  border-radius: 2px;
  border: 1px solid #e0e0e0;
`;
const PrizeName = styled(ItemName)`
  font-size: 12px;
  line-height: 16px;
  color: #333;
`;
const DiscountWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
`;
const ListedPrice = styled(Currency)(({ lineThrough, theme, size, horizontal }) => `
  text-decoration: ${lineThrough ? "line-through" : "none"};
  color: ${theme.colors.gray130};
  font-size: ${size === "md" ? "0.75rem" : "1.25rem"};
  margin-left: ${horizontal ? "6px" : ""};
`);
const DetailTable = ({
  products
}) => {
  return /* @__PURE__ */ React.createElement(OrderItemsWrapper, null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(TableHead, {
    direction: "left"
  }, t("S\u1EA3n ph\u1EA9m")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "right"
  }, t("Gi\xE1 tr\u1ECB")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "center"
  }, t("S\u1ED1 l\u01B0\u1EE3ng")), /* @__PURE__ */ React.createElement(TableHead, {
    direction: "right"
  }, t("T\u1ED5ng ti\u1EC1n")))), /* @__PURE__ */ React.createElement("tbody", null, products.map(({
    name,
    displayName,
    imageUrl,
    sku,
    price,
    unitPrice,
    quantity,
    finalPrice,
    prizes = []
  }, index) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: index
  }, /* @__PURE__ */ React.createElement(OrderProduct, null, /* @__PURE__ */ React.createElement(ProductItem, null, /* @__PURE__ */ React.createElement(ItemImg, {
    src: imageUrl,
    alt: "item"
  }), /* @__PURE__ */ React.createElement(ProductItemRight, null, /* @__PURE__ */ React.createElement(CustomLink, {
    targetPath: `/${slug(name)}-s${sku}.html`,
    targetType: "_blank",
    passHref: true
  }, /* @__PURE__ */ React.createElement(ItemName, null, displayName || name)), /* @__PURE__ */ React.createElement(ItemSku, null, "SKU: ", sku))), /* @__PURE__ */ React.createElement(ItemPrice, null, /* @__PURE__ */ React.createElement(Currency, {
    space: true,
    underline: true,
    value: price
  }), unitPrice && unitPrice !== price && /* @__PURE__ */ React.createElement(DiscountWrapper, null, /* @__PURE__ */ React.createElement(ListedPrice, {
    horizontal: false,
    size: "md",
    value: unitPrice,
    lineThrough: true
  }))), /* @__PURE__ */ React.createElement(ItemQuantity, null, quantity.toLocaleString("vi-VN")), /* @__PURE__ */ React.createElement(ItemFinalPrice, null, /* @__PURE__ */ React.createElement(Currency, {
    space: true,
    underline: true,
    value: finalPrice
  }))), prizes.map(({ name: name2, imageUrl: imageUrl2, price: price2, quantity: quantity2 }, index2) => /* @__PURE__ */ React.createElement(OrderPrize, {
    key: index2
  }, /* @__PURE__ */ React.createElement(PrizeItem, {
    last: prizes.length - 1 === index2
  }, /* @__PURE__ */ React.createElement(PrizeImg, {
    src: imageUrl2,
    alt: "item"
  }), /* @__PURE__ */ React.createElement(PrizeName, null, name2)), /* @__PURE__ */ React.createElement(ItemPrice, null, /* @__PURE__ */ React.createElement(Currency, {
    space: true,
    underline: true,
    value: price2
  })), /* @__PURE__ */ React.createElement(ItemQuantity, null, quantity2.toLocaleString("vi-VN")))), index !== products.length - 1 && /* @__PURE__ */ React.createElement(TableDivider, {
    colCount: 4,
    ml: 116,
    mr: 16
  })))));
};

export { DetailTable };
